import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {exportReport} from "../../util/ApiUtils";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import { t } from '../../i18n';
import MuiTable from "../common/MuiTable";
import {
    legalActs, legalRegs,
    saveOrUpdateAct, saveOrUpdateReg,
    deleteAct, deleteReg, saveOrUpdateCop, deleteCop, legalCops
} from "../../util/PlanningApiUtils";
import {Spinner} from "../common/Spinner";
import {withStyles} from "@material-ui/styles";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (theme => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    'input': {
        '&::placeholder': {
            textOverflow: 'ellipsis !important',
            background: 'yellow'
        }
    },
}));

const columns = [
    {
        title: t('planning.legal.columns.titleOfAct'),
        field: 'title',
        type: "textarea",
    },
    {
        title: t('planning.legal.columns.link'),
        field: 'link',
        render: rowData => { console.log('rowData', rowData); return rowData.link && <a href={rowData.link.startsWith('http') ? rowData.link : `http://${rowData.link}`} target="_blank">{rowData.link}</a>},
    },
    {
        title: t('planning.legal.columns.dateReviewed'),
        field: 'reviewedDate',
        type: "date",
    },
    {
        title: t('common.comments'),
        field: 'comments',
        type: "textarea",
    },
];

const regColumns = [
    {
        title: t('planning.legal.columns.titleOfRegulation'),
        field: 'title',
        type: "textarea",
    },
    {
        title: t('planning.legal.columns.link'),
        field: 'link',
        render: rowData => { console.log('rowData', rowData); return rowData.link && <a href={rowData.link.startsWith('http') ? rowData.link : `http://${rowData.link}`} target="_blank">{rowData.link}</a>},
    },
    {
        title: t('planning.legal.columns.dateReviewed'),
        field: 'reviewedDate',
        type: "date",
    },
    {
        title: t('common.comments'),
        field: 'comments',
        type: "textarea",
    },
];

const coPColumns = [
    {
        title: t('planning.legal.columns.titleOfCodeOfPractice'),
        field: 'title',
        type: "textarea",
    },
    {
        title: t('planning.legal.columns.link'),
        field: 'link',
        render: rowData => { console.log('rowData', rowData); return rowData.link && <a href={rowData.link.startsWith('http') ? rowData.link : `http://${rowData.link}`} target="_blank">{rowData.link}</a>},
    },
    {
        title: t('planning.legal.columns.dateReviewed'),
        field: 'reviewedDate',
        type: "date",
    },
    {
        title: t('common.comments'),
        field: 'comments',
        type: "textarea",
    },
];

class Legal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            acts: [],
            regulations: [],
            cops: [],
            isLoading: true,
            show: false,
        };
        this.loadLegalActs = this.loadLegalActs.bind(this);
        this.loadLegalRegs = this.loadLegalRegs.bind(this);
        this.loadLegalCops = this.loadLegalCops.bind(this);
        this.handleSubmitAct = this.handleSubmitAct.bind(this);
        this.handleSubmitReg = this.handleSubmitReg.bind(this);
        this.handleSubmitCoP = this.handleSubmitCoP.bind(this);
        this.handleDeleteAct = this.handleDeleteAct.bind(this);
        this.handleDeleteReg = this.handleDeleteReg.bind(this);
        this.handleDeleteCoP = this.handleDeleteCoP.bind(this);
    }

    componentDidMount() {
        this.loadLegalActs();
        this.loadLegalRegs();
        this.loadLegalCops();
    }

    loadLegalActs() {
        legalActs()
            .then(response => {
                console.log('loaded', response);
                this.setState({
                    acts: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadLegalRegs() {
        legalRegs()
            .then(response => {
                console.log('loaded', response);
                this.setState({
                    regulations: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadLegalCops() {
        legalCops()
            .then(response => {
                console.log('loaded', response);
                this.setState({
                    cops: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleDeleteAct(data) {
        console.log('delete', data);
        deleteAct(data)
            .then(() => {
                this.loadLegalActs();
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
            }).catch(
            error => {
                console.log("error");
                console.log(error);
                NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
            });
    }

    handleDeleteReg(data) {
        console.log('delete', data);
        deleteReg(data)
            .then(() => {
                this.loadLegalRegs();
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
            }).catch(
            error => {
                console.log("error");
                console.log(error);
                NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
            });
    }

    handleDeleteCoP(data) {
        console.log('delete', data);
        deleteCop(data)
            .then(() => {
                this.loadLegalCops();
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
            }).catch(
            error => {
                console.log("error");
                console.log(error);
                NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
            });
    }

    isValid(newData) {
        /*let isValid = newData.name && newData.name !== '' && newData.description && newData.description !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Name and Description are required fields', 5000);
        }
        return isValid;*/
        // for now its always valid
        return true;
    }

    handleSubmitAct(data) {
        saveOrUpdateAct(data)
            .then(() => {
                this.loadLegalActs();
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    handleSubmitReg(data) {
        saveOrUpdateReg(data)
            .then(() => {
                this.loadLegalRegs();
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    handleSubmitCoP(data) {
        saveOrUpdateCop(data)
            .then(() => {
                this.loadLegalCops();
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    render() {
        const { state } = this;
        const { classes } = this.props;

        if (state.isLoading) {
            return <Spinner/>;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div className={classes.form}>
            <Typography component="h2" variant="h5">
                <span style={{color: "darkblue"}}>
                    <p><b>{ t('planning.legalRequirements') }</b></p>
                </span>
            </Typography>
            <MuiTable
                title={ t('planning.acts') }
                columns={columns}
                data={state.acts}
                onAdd={this.handleSubmitAct}
                onUpdate={this.handleSubmitAct}
                onDelete={this.handleDeleteAct}
                exportButton={!isDemo && !isViewer}
                onExport={() => exportReport('/planning/legal/act/export')}
                isValid={this.isValid}
                pageSize={10}
                allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
            />
            <br/>
            <MuiTable
                title={ t('planning.regulations') }
                columns={regColumns}
                data={state.regulations}
                onAdd={this.handleSubmitReg}
                onUpdate={this.handleSubmitReg}
                onDelete={this.handleDeleteReg}
                exportButton={!isDemo && !isViewer}
                onExport={() => exportReport('/planning/legal/regulation/export')}
                isValid={this.isValid}
                pageSize={10}
                allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
            />
            <br/>
            <MuiTable
                title={ t('planning.codeOfPractice') }
                columns={coPColumns}
                data={state.cops}
                onAdd={this.handleSubmitCoP}
                onUpdate={this.handleSubmitCoP}
                onDelete={this.handleDeleteCoP}
                exportButton={!isDemo && !isViewer}
                onExport={() => exportReport('/planning/legal/code_of-practice/export')}
                isValid={this.isValid}
                pageSize={10}
                allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
            />
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(Legal);
